var map = {
	"./custom/banner.jpeg": 5220,
	"./custom/contact-us-bg.jpg": 9759,
	"./custom/event-img-1.jpg": 7410,
	"./custom/home-banner-1.jpeg": 257,
	"./custom/infrastructure/1.jpg": 7103,
	"./custom/infrastructure/10.jpg": 1385,
	"./custom/infrastructure/11.jpg": 525,
	"./custom/infrastructure/12.jpg": 4772,
	"./custom/infrastructure/13.jpg": 4719,
	"./custom/infrastructure/14.jpg": 4541,
	"./custom/infrastructure/15.jpg": 7958,
	"./custom/infrastructure/16.jpg": 3208,
	"./custom/infrastructure/2.jpg": 1613,
	"./custom/infrastructure/3.jpg": 3927,
	"./custom/infrastructure/4.jpg": 8507,
	"./custom/infrastructure/5.jpg": 1921,
	"./custom/infrastructure/6.jpg": 1800,
	"./custom/infrastructure/7.jpg": 2191,
	"./custom/infrastructure/8.jpg": 561,
	"./custom/infrastructure/9.jpg": 1184,
	"./custom/logo-light-white.png": 1226,
	"./custom/logo-light.png": 5623,
	"./custom/social-projects-banner.jpg": 3791,
	"./custom/video-thumbnail.webp": 6689,
	"./svg/001-donate-2.svg": 171,
	"./svg/002-donate-1.svg": 2099,
	"./svg/003-money-bag.svg": 2048,
	"./svg/004-donation-9.svg": 3923,
	"./svg/005-charity-4.svg": 4179,
	"./svg/006-woman.svg": 9995,
	"./svg/007-church.svg": 1683,
	"./svg/008-bible.svg": 3650,
	"./svg/009-loudspeaker.svg": 7502,
	"./svg/010-people.svg": 5867,
	"./svg/011-heart-box.svg": 431,
	"./svg/012-balance.svg": 4135,
	"./svg/013-heart.svg": 7952,
	"./svg/014-donate.svg": 7800,
	"./svg/015-donation-8.svg": 4452,
	"./svg/016-blood.svg": 7658,
	"./svg/017-man.svg": 5135,
	"./svg/018-donation-7.svg": 8130,
	"./svg/019-donation-6.svg": 4481,
	"./svg/020-location.svg": 6304,
	"./svg/021-gift.svg": 2390,
	"./svg/022-donation-5.svg": 657,
	"./svg/023-ecology.svg": 9807,
	"./svg/024-wheelchair.svg": 8357,
	"./svg/025-first-aid-kit.svg": 5259,
	"./svg/026-transfusion.svg": 8632,
	"./svg/027-solidarity-1.svg": 9184,
	"./svg/028-ribbon-2.svg": 1202,
	"./svg/029-balloon.svg": 1830,
	"./svg/030-donation-4.svg": 4284,
	"./svg/031-package.svg": 4077,
	"./svg/032-bread.svg": 2725,
	"./svg/033-donation-3.svg": 9224,
	"./svg/034-charity-3.svg": 1346,
	"./svg/035-donation-2.svg": 5403,
	"./svg/036-mail.svg": 5740,
	"./svg/037-money.svg": 8220,
	"./svg/038-shirt.svg": 6468,
	"./svg/039-charity-2.svg": 3787,
	"./svg/040-ribbon-1.svg": 9710,
	"./svg/041-house-1.svg": 6566,
	"./svg/042-house.svg": 4562,
	"./svg/043-donation-1.svg": 3273,
	"./svg/044-donation.svg": 2915,
	"./svg/045-charity-1.svg": 5949,
	"./svg/046-solidarity.svg": 3732,
	"./svg/047-world-grid.svg": 4692,
	"./svg/048-ribbon.svg": 2024,
	"./svg/049-smartphone.svg": 8882,
	"./svg/050-charity.svg": 7767,
	"./svg/1_basket.svg": 6254,
	"./svg/1_blood.svg": 4269,
	"./svg/1_charity.svg": 2278,
	"./svg/1_donate.svg": 6755,
	"./svg/1_earth.svg": 3326,
	"./svg/1_hand.svg": 4578,
	"./svg/1_hand_love.svg": 218,
	"./svg/1_house.svg": 9413,
	"./svg/1_kids.svg": 5825,
	"./svg/1_love.svg": 9839,
	"./svg/1_money.svg": 3656,
	"./svg/1_money_hand.svg": 5354,
	"./svg/1_nature.svg": 4400,
	"./svg/1_people.svg": 5668,
	"./svg/1_t-shirt.svg": 4393,
	"./svg/1_tape.svg": 5591,
	"./svg/2_animal_shelter.svg": 813,
	"./svg/2_beggar.svg": 4472,
	"./svg/2_charity.svg": 6273,
	"./svg/2_child.svg": 5721,
	"./svg/2_cooking.svg": 4205,
	"./svg/2_delivery.svg": 6604,
	"./svg/2_disabled.svg": 3570,
	"./svg/2_donate.svg": 9386,
	"./svg/2_homeless.svg": 9552,
	"./svg/2_love.svg": 1729,
	"./svg/2_money.svg": 5134,
	"./svg/2_money_hand.svg": 893,
	"./svg/2_pc_donate.svg": 5880,
	"./svg/2_phone_donate.svg": 3357,
	"./svg/2_piggy_bank.svg": 3594,
	"./svg/2_receipt.svg": 4507,
	"./svg/3_blood.svg": 8323,
	"./svg/3_childs_hand.svg": 3623,
	"./svg/3_donat_money.svg": 2532,
	"./svg/3_donate.svg": 5333,
	"./svg/3_earth.svg": 5412,
	"./svg/3_food.svg": 1622,
	"./svg/3_hand.svg": 7823,
	"./svg/3_help.svg": 213,
	"./svg/3_house.svg": 1119,
	"./svg/3_love.svg": 6564,
	"./svg/3_love_hand.svg": 3575,
	"./svg/3_money.svg": 1021,
	"./svg/3_piggy_bank.svg": 5493,
	"./svg/3_pram.svg": 3501,
	"./svg/3_present.svg": 921,
	"./svg/3_tape.svg": 3101,
	"./svg/bag.svg": 3386,
	"./svg/blood.svg": 232,
	"./svg/bread.svg": 7749,
	"./svg/charity.svg": 4646,
	"./svg/check.svg": 9889,
	"./svg/church.svg": 603,
	"./svg/clock.svg": 9628,
	"./svg/close.svg": 7863,
	"./svg/donate-1.svg": 3522,
	"./svg/donation.svg": 3130,
	"./svg/envelope.svg": 2295,
	"./svg/logo.svg": 5222,
	"./svg/man.svg": 2531,
	"./svg/phone-call.svg": 1969,
	"./svg/placeholder.svg": 5839,
	"./svg/previous.svg": 8288,
	"./svg/question.svg": 5832,
	"./svg/remove.svg": 3970,
	"./svg/share.svg": 1300,
	"./svg/shirt.svg": 5326,
	"./svg/symbol/sprite.svg": 6959,
	"./svg/warning.svg": 3940,
	"./theme/404.jpg": 4919,
	"./theme/about-us-2.jpg": 8343,
	"./theme/about-us.jpg": 3667,
	"./theme/about.jpg": 151,
	"./theme/about_2.png": 9668,
	"./theme/about_3.jpg": 5434,
	"./theme/action-block_1.jpg": 1006,
	"./theme/action-block_2.jpg": 6916,
	"./theme/additional_1.jpg": 4070,
	"./theme/additional_2.jpg": 3645,
	"./theme/article.jpg": 6144,
	"./theme/blog-post.jpg": 8332,
	"./theme/blog_1.jpg": 3333,
	"./theme/blog_2.png": 2541,
	"./theme/blog_4.png": 982,
	"./theme/blog_5.jpg": 4182,
	"./theme/blog_6.jpg": 3620,
	"./theme/blog_7.jpg": 6195,
	"./theme/cause_details.jpg": 4987,
	"./theme/causes.jpg": 6140,
	"./theme/causes_1.jpg": 4645,
	"./theme/causes_2.jpg": 6790,
	"./theme/causes_3.jpg": 9048,
	"./theme/causes_4.jpg": 598,
	"./theme/causes_5.jpg": 7005,
	"./theme/causes_6.jpg": 8061,
	"./theme/comment_1.jpg": 5007,
	"./theme/comment_2.jpg": 1294,
	"./theme/comment_3.jpg": 5698,
	"./theme/contacts.jpg": 753,
	"./theme/donation-item_img.jpg": 5639,
	"./theme/donor_1.png": 5168,
	"./theme/donor_2.png": 9283,
	"./theme/donor_3.png": 1359,
	"./theme/donor_4.png": 3663,
	"./theme/donor_5.png": 7454,
	"./theme/donor_6.png": 7772,
	"./theme/donor_7.png": 5352,
	"./theme/donor_8.png": 217,
	"./theme/donors.jpg": 5936,
	"./theme/event_1.jpg": 9960,
	"./theme/event_2.jpg": 3107,
	"./theme/event_3.jpg": 9383,
	"./theme/event_4.jpg": 6302,
	"./theme/event_5.jpg": 9665,
	"./theme/event_6.jpg": 7581,
	"./theme/event_7.jpg": 2674,
	"./theme/event_8.jpg": 559,
	"./theme/event_9.jpg": 8891,
	"./theme/events.jpg": 706,
	"./theme/f3_ig-1.jpg": 2072,
	"./theme/f3_ig-2.jpg": 6830,
	"./theme/f3_ig-3.jpg": 2937,
	"./theme/f3_ig-4.jpg": 3122,
	"./theme/f3_ig-5.jpg": 3388,
	"./theme/f3_ig-6.jpg": 5927,
	"./theme/face_1.jpg": 1382,
	"./theme/face_2.jpg": 9388,
	"./theme/face_3.jpg": 5511,
	"./theme/face_4.jpg": 6110,
	"./theme/face_5.jpg": 1118,
	"./theme/face_6.jpg": 9461,
	"./theme/faq.jpg": 2155,
	"./theme/faq_aside.jpg": 2777,
	"./theme/front-3_blog-1.jpg": 8247,
	"./theme/front-3_blog-2.jpg": 9506,
	"./theme/front-3_event-1.jpg": 2090,
	"./theme/front-3_event-2.jpg": 4353,
	"./theme/front-3_event-3.jpg": 5948,
	"./theme/front-3_promo-2.jpg": 9502,
	"./theme/front-3_promo-3.jpg": 5692,
	"./theme/front-3_promo.jpg": 896,
	"./theme/gallery.jpg": 9445,
	"./theme/gallery_1.jpg": 8454,
	"./theme/gallery_2.jpg": 5708,
	"./theme/gallery_3.jpg": 3765,
	"./theme/gallery_4.jpg": 6523,
	"./theme/gallery_5.jpg": 1746,
	"./theme/gallery_6.jpg": 1038,
	"./theme/gallery_7.jpg": 5127,
	"./theme/gallery_8.jpg": 2134,
	"./theme/icon_1-1.png": 2686,
	"./theme/icon_1.png": 398,
	"./theme/icon_2-2.png": 7192,
	"./theme/icon_2.png": 9473,
	"./theme/icon_3-3.png": 2056,
	"./theme/icon_3.png": 1461,
	"./theme/icon_4-4.png": 843,
	"./theme/icon_4.png": 1320,
	"./theme/icon_5-5.png": 8941,
	"./theme/icon_6-6.png": 1286,
	"./theme/icon_7-7.png": 7126,
	"./theme/icon_8-8.png": 5913,
	"./theme/ig_1.jpg": 8695,
	"./theme/ig_2.jpg": 7733,
	"./theme/ig_3.jpg": 642,
	"./theme/ig_4.jpg": 573,
	"./theme/ig_5.jpg": 5370,
	"./theme/ig_6.jpg": 8136,
	"./theme/ig_7.jpg": 5194,
	"./theme/ig_8.jpg": 3790,
	"./theme/img_box-1.jpg": 4661,
	"./theme/info-banner_img.png": 5118,
	"./theme/info_img.png": 3167,
	"./theme/klarna.png": 2443,
	"./theme/lion.jpg": 3825,
	"./theme/marker.png": 7725,
	"./theme/paypal.png": 6652,
	"./theme/pricing.jpg": 4407,
	"./theme/pricing_bg-2.jpg": 5575,
	"./theme/pricing_bg.jpg": 6549,
	"./theme/projects-slider_1.jpg": 4744,
	"./theme/projects-slider_2.jpg": 3421,
	"./theme/projects-slider_3.jpg": 9093,
	"./theme/projects_1.jpg": 526,
	"./theme/projects_2.jpg": 63,
	"./theme/projects_3.jpg": 1511,
	"./theme/projects_4.jpg": 5844,
	"./theme/projects_5.jpg": 3731,
	"./theme/projects_6.jpg": 2859,
	"./theme/promo_1.jpg": 9154,
	"./theme/promo_2-2.jpg": 8825,
	"./theme/promo_2.jpg": 1679,
	"./theme/promo_3.jpg": 1071,
	"./theme/recent_1.jpg": 4371,
	"./theme/recent_2.jpg": 1719,
	"./theme/recent_3.jpg": 7294,
	"./theme/shop.jpg": 9902,
	"./theme/shop_1.png": 2441,
	"./theme/shop_2.png": 3498,
	"./theme/shop_3.png": 6508,
	"./theme/shop_4.png": 1916,
	"./theme/shop_5.png": 646,
	"./theme/shop_6.png": 9210,
	"./theme/shop_7.jpg": 9437,
	"./theme/shop_8.jpg": 9818,
	"./theme/shop_9.jpg": 4800,
	"./theme/single_1.png": 9655,
	"./theme/single_2.png": 6646,
	"./theme/single_3.png": 5693,
	"./theme/storie_1.jpg": 9632,
	"./theme/storie_2.jpg": 476,
	"./theme/storie_3.jpg": 1924,
	"./theme/storie_4.jpg": 4928,
	"./theme/storie_details-img.jpg": 1305,
	"./theme/storie_details.jpg": 2567,
	"./theme/stories.jpg": 4304,
	"./theme/team_1.jpg": 7699,
	"./theme/team_2.jpg": 1538,
	"./theme/team_3.jpg": 8320,
	"./theme/team_4.jpg": 556,
	"./theme/team_5.jpg": 242,
	"./theme/team_6.jpg": 8863,
	"./theme/team_7.jpg": 8909,
	"./theme/team_8.jpg": 6939,
	"./theme/typography.jpg": 9805,
	"./theme/video_block-2.jpg": 5332,
	"./theme/video_block-3.jpg": 2977,
	"./theme/video_block.jpg": 1987,
	"./theme/video_frame-2.jpg": 7526,
	"./theme/video_frame.png": 5496,
	"./theme/visa.png": 5044,
	"./theme/volunteer.jpg": 3274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;